import { getPersistedSession } from "components";

export type AppointmentDetailUrlParams = { id?: string; locationId?: string; woNr: string };

export const REDIRECT_HANDLER_URL = "redirectUrlHandler";
const URL_HANDLER_REGEX = /appointments\/\d+(?:\/\d+)?$/;

export const useStoreRedirectUrlParam = () => {
  const session = getPersistedSession();

  if (session?.token || !URL_HANDLER_REGEX.test(window.location.pathname)) return;

  localStorage.setItem(REDIRECT_HANDLER_URL, window.location.pathname);
};
